import userInfo from './userInfo';
import goodnightUserInfo from './goodnightUserinfo';
import goodnightUserinfo2019 from './goodnight2019';
import goodnightUserinfo2020 from './goodnight2020';
import goodnightUserinfo2021 from './goodnight2021';
import goodnightUserinfo2022 from './goodnight2022';
import goodHubei from './goodHubei';
import kuakua from "./kuakuaTreeHole";
import worldSmile from  "./worldSmile"
export default {
	userInfo,
	goodnightUserInfo,
	goodnightUserinfo2019,
	goodnightUserinfo2020,
	goodnightUserinfo2021,
	goodnightUserinfo2022,
	goodHubei,
	kuakua,
	worldSmile
};



// WEBPACK FOOTER //
// ./src/redux/reducers/thefair/index.js